import React from 'react';
const PROMISES = [
  { icon:'🔍', title:'All-Inclusive Fares', desc:'Every price we show includes taxes, fees and carrier surcharges. The price you see is the price you pay at checkout.', col:'from-navy-800 to-navy-600' },
  { icon:'🛡️', title:'Price Match Promise', desc:'Find the same flight cheaper anywhere within 24 hours of booking? We\'ll match it and refund the difference, no questions asked.', col:'from-amber-500 to-amber-400' },
  { icon:'📋', title:'Full Fare Breakdown', desc:'Every booking shows a detailed line-by-line fare breakdown before you pay. Taxes, fees, extras — everything is visible upfront.', col:'from-navy-900 to-navy-700' },
  { icon:'🔒', title:'Secure & PCI Compliant', desc:'Bank-grade 256-bit SSL encryption and PCI-DSS certified payment processing. Your financial data is never stored on our servers.', col:'from-amber-600 to-amber-500' },
];
export default function FareGuarantee() {
  return (
    <section className="py-14 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-bold text-navy-800 uppercase tracking-widest bg-navy-50 border border-navy-100 px-4 py-1.5 rounded-full mb-3">Our Commitment to You</span>
          <h2 className="font-display text-3xl sm:text-4xl font-extrabold text-navy-950 mb-3">The TheAirlineFares Promise</h2>
          <p className="text-gray-500 max-w-xl mx-auto text-sm sm:text-base">We built this platform on one principle: travelers deserve honest prices and complete transparency.</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {PROMISES.map(p => (
            <div key={p.title} className="bg-gray-50 border border-gray-100 rounded-2xl p-6 text-center hover:shadow-lg hover:border-navy-100 transition-all">
              <div className={'w-14 h-14 bg-gradient-to-br '+p.col+' rounded-2xl flex items-center justify-center text-2xl mx-auto mb-4 shadow-md'}>{p.icon}</div>
              <h3 className="font-bold text-gray-900 mb-2 text-sm">{p.title}</h3>
              <p className="text-gray-500 text-xs leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
